'use client';

import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

interface Step {
  label: string;
}

interface WizardStepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export function WizardStepIndicator({ steps, currentStep }: WizardStepIndicatorProps) {
  return (
    <div className="flex items-center justify-center mb-8">
      {steps.map((step, index) => {
        const isComplete = index < currentStep;
        const isActive = index === currentStep;
        const isFuture = index > currentStep;

        return (
          <div key={step.label} className="flex items-center">
            {/* Step circle */}
            <div className="flex flex-col items-center">
              <div
                className={cn(
                  'flex h-8 w-8 items-center justify-center rounded-full text-sm font-semibold transition-colors',
                  isComplete && 'bg-growth-green text-white',
                  isActive && 'bg-trust-blue text-white',
                  isFuture && 'bg-warm-gray-200 text-warm-gray-500'
                )}
              >
                {isComplete ? <Check className="h-4 w-4" /> : index + 1}
              </div>
              <span
                className={cn(
                  'mt-1 text-xs hidden sm:block',
                  isComplete && 'text-growth-green font-medium',
                  isActive && 'text-trust-blue font-medium',
                  isFuture && 'text-warm-gray-400'
                )}
              >
                {step.label}
              </span>
            </div>

            {/* Connector line */}
            {index < steps.length - 1 && (
              <div
                className={cn(
                  'mx-2 h-0.5 w-8 sm:w-12 transition-colors',
                  index < currentStep ? 'bg-growth-green' : 'bg-warm-gray-200'
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
